import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extendReportViewFactory('site-verification')
  .factory()

export {
  Provider as SiteVerificationReportProvider,
  useStore as useSiteVerificationReportStore,
}
